import { useCallback, useRef } from 'react'
import { useEvent } from './useEvent'

interface UseResizeObserverOptions {
  onResize: () => void
}

export const useResizeObserver = ({ onResize }: UseResizeObserverOptions): (el: HTMLElement | null) => void => {
  const onResizeEvent = useEvent(onResize)
  const observer = useRef<ResizeObserver | undefined>(undefined)
  const onRefed = useCallback(
    (el: HTMLElement | null) => {
      if (observer.current) {
        observer.current.disconnect()
        observer.current = undefined
      }

      if (el) {
        const newObserver = new ResizeObserver(() => {
          onResizeEvent()
        })
        newObserver.observe(el)
        observer.current = newObserver
      }
    },
    [onResizeEvent]
  )

  return onRefed
}
